export const features = {
  garage: false,
  fits_for_car: false,
  product_variations: false,
  product_related: false,
  product_rating: false,
  menu: false,
  discount: false
};